import ACTION_ITEMS from '../../../actionItems';

export function setSelectedGroup(group) {
  return {
    type: ACTION_ITEMS.TEAM_VIEWER.GROUPS.SELECTED,
    payload: group,
  };
}
